<template>
    <div class="content-wrapper">
        <div class="user-profile mb-primary">
            <div class="card position-relative card-with-shadow py-primary border-0">
                <app-overlay-loader v-if="componentLoader" class="h-100" />
                <div v-else class="row align-items-center">
                    <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-5">
                        <div class="media border-right px-5 pr-xl-5 pl-xl-0 align-items-center user-header-media">
                                <div class="profile-pic-wrapper position-relative text-center"
                                @dblclick="showPhoto">
                                    <app-overlay-loader v-if="preloader" />
                                    <app-input v-else id="escorter_photo" class="circle mx-xl-auto"
                                        :wrapper-class="'circle mx-xl-auto'" name="escorter_photo" type="custom-file-upload"
                                        v-model="escorter.photo" :generate-file-url="false" @change.prevent="setPhoto"
                                        :label="$t('photo')" />
                                </div>
                                <div class="profile-pic-wrapper position-relative text-center" @dblclick="showCard">
                                    <app-overlay-loader v-if="preloader" />
                                    <app-input v-else id="escorter_card" class="mx-xl-auto"
                                        :wrapper-class="'mx-xl-auto'" name="escorter_card" type="custom-file-upload"
                                        v-model="escorter.card" :generate-file-url="false" @change.prevent="setIdCard"
                                        :label="$t('id_card')" />
                                </div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-7">
                        <div
                            class="user-details px-5 px-sm-5 px-md-5 px-lg-0 px-xl-0 mt-5 mt-sm-5 mt-md-0 mt-lg-0 mt-xl-0">
                            <div class="row">
                                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6">
                                    <div class="border-right custom">
                                        <div class="media mb-4 mb-xl-5">
                                            <div class="align-self-center mr-3">
                                                <app-icon :name="'user'" />
                                            </div>
                                            <div class="media-body">
                                                <p class="text-muted mb-0">{{ $t('escorter_name') }}:</p>
                                                <p class="mb-0">
                                                    {{ escorter.selectedEscorter.first_name }}
                                                    {{ escorter.selectedEscorter.middle_name }}
                                                    {{ escorter.selectedEscorter.last_name }}
                                                </p>
                                            </div>
                                        </div>
                                        <div class="media mb-4 mb-xl-0">
                                            <div class="align-self-center mr-3">
                                                <app-icon :name="'map-pin'" />
                                            </div>
                                            <div class="media-body">
                                                <p class="text-muted mb-0">{{ $t('address') }}:</p>
                                                <p class="mb-0">{{ escorter.selectedEscorter.address }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6">
                                    <div class="media mb-4 mb-xl-5">
                                        <div class="align-self-center mr-3">
                                            <app-icon :name="'phone'" />
                                        </div>
                                        <div class="media-body">
                                            <p class="text-muted mb-0">{{ $t('contact') }}:</p>
                                            <p class="mb-0">{{ escorter.selectedEscorter.phone }}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="media mb-0 mb-xl-0">
                                        <div class="align-self-center mr-3">
                                            <app-icon :name="'gift'" />
                                        </div>
                                        <div class="media-body">
                                            <p class="text-muted mb-0">{{ $t('date_of_birth') }}:</p>
                                            <p class="mb-0">{{
                                                escorter.selectedEscorter.date_of_birth ?
                                                escorter.selectedEscorter.date_of_birth :
                                                $t('not_available') }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <app-tab :tabs="tabs" :icon="tabIcon" type="horizontal" />
    </div>
</template>

<script>

import { mapState } from "vuex";
import { FormMixin } from "../../../../core/mixins/form/FormMixin";
import { urlGenerator } from "../../../Helpers/AxiosHelper";
import { UserMixin } from "../Auth/Mixins/UserMixin";

export default {
    name: "EscorterDetails",
    mixins: [FormMixin, UserMixin],
    props: {
        escorterId: {},
    },
    computed: {
        ...mapState({
            escorter: state => state.escorter
        }),
    },
    data() {
        return {
            preloader: false,
            componentLoader: true,
            tabIcon: 'user',
            tabs: [
                {
                    'name': this.$t('personal_info'),
                    'title': this.$t('personal_info'),
                    'component': 'escorter-personal-info',
                    'permission': ''
                },
            ]
        }
    },
    mounted() {
        if (!_.isEmpty(this.escorter.selectedEscorter))
            this.componentLoader = false;
        const payload = { escorterId: this.escorterId };
        this.$store.dispatch('getEscorter', payload);
    },
    methods: {
        beforeSubmit() {
            this.preloader = true;
        },
        showPhoto() {
            // Create a URL for the Blob
            const blobUrl = URL.createObjectURL(this.escorter.photo);
            
            // Set the desired width and height of the popup window
            const width = 800;
            const height = 800;
            
            // Calculate the position to center the popup on the screen
            const left = (screen.width / 2) - (width / 2);
            const top = (screen.height / 2) - (height / 2);
            
            // Open the Blob in a new centered window
            window.open(blobUrl, '_blank', `width=${width}, height=${height}, top=${top}, left=${left}`);
        },
        showCard() {
                        // Create a URL for the Blob
            const blobUrl = URL.createObjectURL(this.escorter.card);
            
            // Set the desired width and height of the popup window
            const width = 800;
            const height = 800;
            
            // Calculate the position to center the popup on the screen
            const left = (screen.width / 2) - (width / 2);
            const top = (screen.height / 2) - (height / 2);
            
            // Open the Blob in a new centered window
            window.open(blobUrl, '_blank', `width=${width}, height=${height}, top=${top}, left=${left}`);
        },
        setPhoto($event) {
            const fileValue = $event.target.files[0];
            let formData = new FormData();
            formData.append('photo', fileValue);
            this.submitFromFixin("post", `escorters/${this.escorterId}/photo`, formData);
        },
        setIdCard($event) {
            const fileValue = $event.target.files[0];
            let formData = new FormData();
            formData.append('id_card', fileValue);
            this.submitFromFixin("post", `escorters/${this.escorterId}/card`, formData);
        },
        afterFinalResponse() {
            this.preloader = false;
            const payload = { escorterId: this.escorterId };
            this.$store.dispatch('getEscorter', payload);
        },
        afterSuccess(res) {
            this.$toastr.s(res.data.message);
        },
    }
}
</script>
<style scoped>
.user-profile .card {
    min-height: 190px;
}
</style>
